import { formatCell, formatLoadingCell } from '../utils/formatCell';
import { useMemo } from 'react';
import { usePortalTranslations } from 'portals-platform-lib';
import { usePortalData } from '../data/usePortalData';
export const useTicketListingsColumns = (isLoading, isGrid = false) => {
  const {
    data
  } = usePortalData();
  const {
    portalText
  } = usePortalTranslations();
  return useMemo(() => data === null || data === void 0 ? void 0 : data.configuredTicketListProperties.map(x => x).sort((a, b) => a.displayOrder - b.displayOrder).map(property => {
    const {
      displayNameOverride,
      propertyName
    } = property;
    return {
      id: propertyName,
      accessorKey: propertyName,
      header: portalText('SUPPORT_SPACE_LISTINGS_PAGE_TICKET_PROPERTIES', propertyName) || displayNameOverride || propertyName,
      cell: isLoading ? formatLoadingCell(property) : formatCell(property, isGrid)
    };
  }), [data === null || data === void 0 ? void 0 : data.configuredTicketListProperties, isLoading, isGrid, portalText]) || [];
};